import {observer} from 'mobx-react';
import * as React from 'react';
import { useContext, useEffect } from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {useAccount} from 'wagmi';
import folderIcon from '../../../assets/icons/folder.png';
import { useBreakpointContext } from '../../../context-providers/BreakpointProvider';
import { ModalContext } from '../../../context-providers/ModalProvider';
import {ServicesContext} from '../../../context-providers/ServicesProvider';
import {positionsStore} from '../../../services/position/position.store';
import EmptyStateComponent from '../../EmptyState/EmptyState';
import {getDataGridCommonProps} from '../helpers/data-grid-common-props';
import {getHistoryPositionsColumns} from '../helpers/position-columns';
import PositionSmallTableRow from '../small-table-rows/PositionSmallTableRow';

const PAGE_SIZE = 100;
const emptyStateText = 'No history available';

const UserPositionsHistory = observer(() => {

    const { address } = useAccount();
    const { positionsManager } = useContext(ServicesContext);
    const { xs } = useBreakpointContext();
    const { openModal } = useContext(ModalContext);
    const [paginationEnabled, setPaginationEnabled] = React.useState(positionsStore.openPositionsList.length > PAGE_SIZE);

    useEffect(() => {
        setPaginationEnabled(positionsStore.closedPositions.length > PAGE_SIZE);
    }, [positionsStore.closedPositions.length]);


    useEffect(() => {
        if (address) {
            positionsManager.fetchClosedPositions(address);
        } else {
            positionsStore.resetState()
        }
    }, [address])


    return (
        <div className="TradeTabsNavigation__gridWrapper">
            {xs && positionsStore.closedPositions.length ? positionsStore.closedPositions.map((position, index) => {
                return <PositionSmallTableRow key={index} position={position} openModal={openModal}/>;
            }) : null}
            {xs && !positionsStore.closedPositions?.length ?
                <div className="TradeTabsNavigation__xsEmpty card-container"><EmptyStateComponent text={emptyStateText} icon={<img src={folderIcon} alt={emptyStateText}/>} /></div> : null
            }
            {!xs ? <DataGrid
                {...getDataGridCommonProps(emptyStateText)}
                rows={positionsStore.closedPositions}
                columns={getHistoryPositionsColumns()}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'finishedAt', sort: 'desc' }]
                    }
                }}
            /> : null}
        </div>
    );
});

export default UserPositionsHistory;
